import CommandAddItemToCart from '@/models/cart/command/add-item-to-cart'
import { SkuPrice } from '@/models/item/sku'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { addToCartEventFactory } from '@/vendor/gtm/events/ga4/add-to-cart'
import { Either } from 'fp-ts/lib/Either'

export interface AddItemDeps {
  command: CommandAddItemToCart
  dataLayerService: DataLayerService
}
export interface AddItemParam {
  item: {
    id: string
    count: number
    price: SkuPrice
  }
}

type AddItem = (deps: AddItemDeps) => (param: AddItemParam) => Promise<Either<string, void>>
const addItem: AddItem = ({ command, dataLayerService }) => async ({ item }: AddItemParam) => {
  /**
   * この関数は ./AddItemToCart.vue or ./AddItemToCartViaExternalSystem から利用されることを想定している
   * = システム標準のカート追加UIから利用されることを想定している
   * = 複数商品のカート追加を行うことは想定されていない
   *
   * したがって、ここでは固定でリストではなく単体データのみを渡している.
   *
   * @see https://github.com/my-color/front/issues/7013 複数カート追加の考慮が必要になった経緯
   * @see {ContactLensCartIn} 複数カート追加が行われうる、非標準UI
   */
  const result = await command.execute({
    productId: item.id,
    count: item.count,
    price: item.price,
  })

  return result.map(
    (addItemToCartResult) => {
      dataLayerService.push(
        addToCartEventFactory.createFromAddItemToCartResults([addItemToCartResult])
      )
    }
  )
}

export const interaction = {
  addItem,
}
